import { render, staticRenderFns } from "./ProjectFileUploader.vue?vue&type=template&id=63b8f88c&scoped=true&lang=pug&"
import script from "./ProjectFileUploader.vue?vue&type=script&lang=js&"
export * from "./ProjectFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFileUploader.vue?vue&type=style&index=0&id=63b8f88c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8f88c",
  null
  
)

export default component.exports